@if (resourcesLoadingState$ | async; as resourcesLoadingState) {
  @if (resourcesLoadingState.isLoading) {
    <ipo-loading-spinner [size]="30" class="spinner"></ipo-loading-spinner>
  }
  <ipo-dropdown
    [options]="(resourceOptions$ | async)!"
    [selected]="
      !resourcesLoadingState.isLoading ? selectedDropdownOption : undefined
    "
    [placeholder]="
      resourcesLoadingState.isLoading
        ? ''
        : ('resourceFinder.placeholder' | translate)
    "
    [align]="'right'"
    (changed)="onSelectionChanged($event)"
    class="dropdown"
    [allowTextFiltering]="true"
    [filterPlaceholder]="'resourceFinder.filterPlaceholder' | translate"
    [disabled]="resourcesLoadingState.isLoading"
  ></ipo-dropdown>
}
